import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();
const authorizationBearer = TokenService.getAuthorizationBearer();

export const ScenarioAPIService = {
   
    searchScenarios: async function (nodeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/SearchScenarios/' + nodeId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)

            return { error: response };
        }
    },

    downloadScenarios: async function (downloadScenarioDto) {
        let response;

        try {            
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/Download', {
                method: "POST",
                headers: {                    
                    Accept: "application/json",
                    "Content-Type": "application/json",                    
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(downloadScenarioDto)
            });

            return await response.blob();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.blob();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)

            return { error: response }
        }
    },

    getScenariosByScenarioTypeCodeAndMappingTypeId: async function (scenarioTypeCode, mappingTypeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/getScenariosByScenarioTypeCodeAndMappingTypeId/' + scenarioTypeCode + '/' + mappingTypeId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    getNodesByScenarioId: async function (scenarioId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/getNodesByScenarioId/' + scenarioId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    updateScenarioNodes: async function (scenarioNodes) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/UpdateScenarioNodes', {
                method: "PUT",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(scenarioNodes)
            });

            return await response;
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('There was an error', error);
                console.log(scenarioNodes);
            }
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response;
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    getCurrencyBuckets: async function () {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/getCurrencyBuckets', {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    add: async function (newScenario) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/SaveScenario', {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(newScenario)
            });

            return await response.blob();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.blob();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },

    update: async function (newScenario) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Scenario/Update', {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(newScenario)
            });

            return await response.blob();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.blob();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },

    getScenarioByScenarioCode: async function (scenarioCode) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + `/api/Scenario/GetScenariosByScenarioTypeCode/${scenarioCode}`, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
};